import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessDenied from '../../pages/accessDenied';
import SearchProducts from '../../pages/searchProducts/SearchProducts';
import routes from '../../routes/constants';
var Routes = function() {
    return /*#__PURE__*/ React.createElement(Switch, null, /*#__PURE__*/ React.createElement(Route, {
        path: '/embed/instant-search',
        component: SearchProducts
    }), /*#__PURE__*/ React.createElement(Route, {
        exact: true,
        path: routes.accessDenied,
        component: AccessDenied
    }));
};
export default Routes;
